import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['status', 'enableButton', 'disableButton', 'blockedHint']

  connect() {
    this.refreshState()
  }

  async refreshState() {
    if (!this.isSupported()) return this.render('unsupported')

    if (Notification.permission === 'denied') return this.render('blocked')

    const subscription = await this.currentSubscription()
    if (Notification.permission === 'granted' && subscription) return this.render('active')

    this.render('inactive')
  }

  async enable() {
    if (!this.isSupported()) return
    if (Notification.permission === 'denied') return this.refreshState()

    await navigator.serviceWorker.ready
    if (window.pwaManager) {
      await window.pwaManager.subscribeToPush()
    }
    this.refreshState()
  }

  async disable() {
    if (window.pwaManager) {
      await window.pwaManager.unsubscribeFromPush()
    }
    this.refreshState()
  }

  isSupported() {
    return 'Notification' in window && 'serviceWorker' in navigator
  }

  async currentSubscription() {
    try {
      const registration = await navigator.serviceWorker.getRegistration()
      if (!registration) return null
      return await registration.pushManager.getSubscription()
    } catch {
      return null
    }
  }

  render(state) {
    const messages = {
      unsupported: 'Não suportado neste navegador',
      blocked: 'Bloqueado nas configurações do navegador',
      active: 'Ativo neste dispositivo',
      inactive: 'Inativo',
    }

    if (this.hasStatusTarget) this.statusTarget.textContent = messages[state]

    this.toggle(this.enableButtonTarget, state === 'inactive')
    this.toggle(this.disableButtonTarget, state === 'active')
    this.toggle(this.blockedHintTarget, state === 'blocked')
  }

  toggle(el, visible) {
    if (!el) return
    el.classList.toggle('hidden', !visible)
  }
}
